import { Pipe, PipeTransform } from '@angular/core';

import * as day from 'dayjs';

@Pipe({
  name: 'isInPast',
})
export class IsInPastPipe implements PipeTransform {
  transform(date: day.Dayjs | undefined): boolean {
    if (!date || !day.isDayjs(date)) return false;

    return date.isSameOrBefore(day(), 'minute');
  }
}
